import styled, { css } from 'styled-components';

import { DropdownMenuPlacement } from 'components/Dropdown/types/DropdownMenuPlacement';
import { colors, cssBreakpoints, shadows } from 'theme/theme';

const menuContainerPlacementStyles: Record<
  DropdownMenuPlacement,
  ReturnType<typeof css>
> = {
  'top-left': css`
    bottom: 100%;
    left: 0;
  `,
  'top-right': css`
    bottom: 100%;
    right: 0;
  `,
  'bottom-left': css`
    top: 100%;
    right: 0;
  `,
  'bottom-right': css`
    top: 100%;
    left: 0;
  `,
};

export const DropdownMenuHolder = styled.menu<{
  $placement: DropdownMenuPlacement;
  $mobilePlacement: DropdownMenuPlacement;
}>`
  position: absolute;
  border: 1px solid ${colors.calloutGrey};
  box-shadow: ${shadows.toolbar};
  background: ${colors.white};
  border-radius: 8px 0 8px 8px;
  overflow: hidden;
  margin: 0;
  padding: 0;
  z-index: 99;

  @media all and (max-width: ${cssBreakpoints.mdUp}) {
    ${(props) => menuContainerPlacementStyles[props.$mobilePlacement]};
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    ${(props) => menuContainerPlacementStyles[props.$placement]};
  }
`;
